import { render } from "./SensorsMain.vue?vue&type=template&id=5bd9be91&scoped=true&ts=true"
import script from "./SensorsMain.vue?vue&type=script&lang=ts"
export * from "./SensorsMain.vue?vue&type=script&lang=ts"

import "./SensorsMain.vue?vue&type=style&index=0&id=5bd9be91&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd9be91"]])

export default __exports__